import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  ja: {
    "取消": 'キャンセル',
    "确定": '確認',
    "发送": '送信',
    "系统通知": 'システム通知',
    "关闭": '閉じる',
    "图片": '画像',
    "文件": 'ファイル',
    "表情": '表情',
    "视频": '動画',
    "录制": '録画する',
    "拍照": '写真を撮る',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
